<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer006">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/The_Captains_Christmas_Journey#_idTextAnchor001"><em>The Captain's Christmas Journey</em></a> by Carla Kelly</p>
<p class="TOCitem"><span href="#/The_Viscounts_Yuletide_Betrothal#_idTextAnchor022" title="Link target outside of Sample"><em>The Viscount's Yuletide Betrothal</em></span> by Louise Allen</p>
<p class="TOCitem"><span href="#/One_Night_Under_the_Mistletoe#_idTextAnchor032" title="Link target outside of Sample"><em>One Night Under the Mistletoe</em></span> by Laurie Benson</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?7b2833ac